import api from "../api";
import { Store } from "../store";
import { persistor } from "../store";
import i18n from "../translation/i18";

var payloadData = Store.getState();
const setQuestionNumberForApi = (questionstatus) => {
  if (!Array.isArray(questionstatus)) {
    console.error("❌ questionstatus is not an array in setQuestionNumberForApi", questionstatus);
    return "";
  }

  const ids = questionstatus
    .map((item, index) => {
      if (!item || typeof item.ques_id === "undefined") {
        console.warn(`⚠️ Missing ques_id at index ${index}`, item);
        return null; // skip this item
      }
      return item.ques_id.toString();
    })
    .filter((id) => id !== null); // remove invalid ones

  const result = ids.join("#");
  // console.log("✅ Final question numbers string:", result);
  return result;
};


const setAnswerJsonForApi = (answers_json, question_state) => {
  let originaldata = answers_json.map((item, index) => {
    return question_state[index]?.status_number == 4 ||
      question_state[index]?.status_number == 5
      ? item
      : "-1";
  });
  return originaldata.join("#");
};

const setQuestionStatusForApi = (questionstatus) => {
  let data = "";
  questionstatus.map((item, index) => {
    if (index === 0) {
      if (questionstatus.length == 1) {
        data = item.status_number.toString();
      } else {
        data = item.status_number.toString() + "#";
      }
    }
    if (index > 0 && index < questionstatus.length - 1) {
      data = data + item.status_number + "#";
    }
    if (index != 0 && index === questionstatus.length - 1) {
      data = data + item.status_number;
    }
  });
  return data;
};

function setSessionHeaders(payloadData) {
  let sessionKey = "";
  let accountdata = payloadData.institute_data;
  let testdata = payloadData.test_data;
  let studentdata = payloadData.student_data;
  if (
    studentdata != undefined &&
    testdata != undefined &&
    accountdata != undefined
  ) {
    sessionKey =
      studentdata.userid +
      ":" +
      testdata.test_id +
      ":" +
      accountdata.account_id +
      ":" +
      payloadData.session_key;
    sessionKey = btoa(sessionKey);

    return sessionKey;
  }
}

function completedSectionid(payloadData) {
  let sectionId = "";
  payloadData?.subjects_data.find((data) => {
    if (
      "" + data.subject_id + "#" + data.section_id !=
      payloadData.selectedSection
    ) {
      sectionId =
        sectionId + "" + data.subject_id + "#" + data.section_id + ",";
    }

    return (
      "" + data.subject_id + "#" + data.section_id ==
      payloadData.selectedSection
    );
  });
  return sectionId;
}

export default async function saveAndNext(props) {
  try {
    let payloadData = Store.getState();
    // Check user ID before proceeding
    if (payloadData.student_data.userid !== 1234567890) {
      let request = {
        url: `/v1/examPanel/saveTestState`,
        headers: {
          "X-Device-Key": localStorage.getItem("identityKey"),
          "X-Session-Key": setSessionHeaders(payloadData),
        },
        data: {
          data: {
            answers: Array.isArray(payloadData.answers_json)
              ? payloadData.answers_json.join("#")
              : payloadData.answers_json,
            attempt_time: payloadData.attempt_time.join("#"),
            exam_schd_id: payloadData.student_data.student_disp_id,
            files: {},
            filesV2: payloadData.question_fileV2_mapping,
            isComplete: 0,
            language_id: payloadData?.languageSelected,
            is_bookmark: payloadData.is_bookmarked.join("#"),
            question_state: setQuestionStatusForApi(payloadData.questionstatus),
            questions: setQuestionNumberForApi(payloadData.questionstatus),
            student_contact: payloadData.student_data.phone,
            student_disp_id: payloadData.student_data.student_disp_id,
            student_id: payloadData.student_data.student_id,
            student_name: payloadData.student_data.student_name,
            subjective_answer: payloadData.subjective_answer,
            testType: payloadData.test_data.test_type_id,
            test_id: payloadData.test_data.test_id,
            test_start_time: payloadData.startTime,
            test_end_time: payloadData.test_data.test_end_timestamp,
            totalTimeLeft: sessionStorage.getItem("leftTimeToSubmit"),
            user_id: payloadData.student_data.userid,
            completed_section_id: completedSectionid(payloadData),
            current_section_id: payloadData.selectedSection,
            current_section_time: parseInt(
              sessionStorage.getItem("SessionleftTimeToSubmit")
            ),
          },
        },
      };

      await api.postAuthTZ(request);
      // console.log("API call succeeded.");
    }
  } catch (error) {
    console.error("API call failed:", error);

    /* eslint-disable-next-line no-restricted-globals */
    alert(error?.response?.data?.errors?.message || i18n.t('test.unknownError'));
    window.location.href = '/'
        window.close(); 
  }
}

export async function saveAndNextInsection(sectionTime) {
  try {
    let payloadData = Store.getState();

    if (payloadData.student_data.userid !== 1234567890) {
      let request = {
        url: `/v1/examPanel/saveTestState`,
        headers: {
          "X-Device-Key": localStorage.getItem("identityKey"),
          "X-Session-Key": setSessionHeaders(payloadData),
        },
        data: {
          data: {
            answers: Array.isArray(payloadData.answers_json)
              ? payloadData.answers_json.join("#")
              : payloadData.answers_json,
            attempt_time: payloadData.attempt_time.join("#"),
            exam_schd_id: payloadData.student_data.student_disp_id,
            files: {},
            filesV2: payloadData.question_fileV2_mapping,
            isComplete: 0,
            language_id: payloadData?.languageSelected,
            is_bookmark: payloadData.is_bookmarked.join("#"),
            question_state: setQuestionStatusForApi(payloadData.questionstatus),
            questions: setQuestionNumberForApi(payloadData.questionstatus),
            student_contact: payloadData.student_data.phone,
            student_disp_id: payloadData.student_data.student_disp_id,
            student_id: payloadData.student_data.student_id,
            student_name: payloadData.student_data.student_name,
            subjective_answer: payloadData.subjective_answer,
            testType: payloadData.test_data.test_type_id,
            test_id: payloadData.test_data.test_id,
            test_start_time: payloadData.startTime,
            test_end_time: payloadData.test_data.test_end_timestamp,
            totalTimeLeft: sessionStorage.getItem("leftTimeToSubmit"),
            user_id: payloadData.student_data.userid,
            completed_section_id: completedSectionid(payloadData),
            current_section_id: payloadData.selectedSection,
            current_section_time: sectionTime,
          },
        },
      };

      await api.postAuthTZ(request);
    }
  } catch (error) {
    console.error("An error occurred:", error);

    // eslint-disable-next-line no-restricted-globals
    alert(error?.response?.data?.errors?.message || i18n.t('test.unknownError'));
    window.location.href = '/'
      window.close(); 
  }
}
export async function submitTestApi(props, isMannualSubmit = 0) {
  props.dispatch({ type: "TEST_SUBMIT", testSubmitted: false });

  const reduxState = Store.getState();
  const payloadData = reduxState || props.state;

  

  // Fallback for questionstatus
  let questionstatus = Array.isArray(payloadData.questionstatus)
    ? payloadData.questionstatus
    : (payloadData.ques_data || []).map((q) => ({
        ques_id: q.ques_id,
        status_number: 1,
      }));

  // Fallback for answers_json
  let answers_json = Array.isArray(payloadData.answers_json)
    ? payloadData.answers_json
    : new Array(questionstatus.length).fill("-1");

  // Safety log
  // console.log("📦 Final questionstatus:", questionstatus);
  // console.log("📦 Final answers_json:", answers_json);
  // console.log("🧪 [submitTestApi] Debug Snapshot:");
  // console.log("🧩 questionstatus =", questionstatus);
  // console.log("🧩 answers_json =", answers_json);
  // console.log("🧩 ques_data =", payloadData.ques_data);
  // console.log("🧩 subjective_answer =", payloadData.subjective_answer);
  // console.log("🧩 attempt_time =", payloadData.attempt_time);
  // console.log("🧩 is_bookmarked =", payloadData.is_bookmarked);
  
  if (payloadData.student_data.userid !== 1234567890) {
    const request = {
      url: `/v1/examPanel/submitTest`,
      headers: {
        "X-Device-Key": localStorage.getItem("identityKey"),
        "X-Session-Key": setSessionHeaders(payloadData),
      },
      data: {
        data: {
          answers: setAnswerJsonForApi(answers_json, questionstatus),
          attempt_time: (payloadData.attempt_time || []).join("#"),
          exam_schd_id: payloadData.student_data.student_disp_id,
          files: {},
          filesV2: payloadData.question_fileV2_mapping,
          isComplete: 1,
          language_id: payloadData?.languageSelected,
          is_bookmark: (payloadData.is_bookmarked || []).join("#"),
          question_state: setQuestionStatusForApi(questionstatus),
          questions: setQuestionNumberForApi(questionstatus),
          student_contact: payloadData.student_data.phone,
          student_disp_id: payloadData.student_data.student_disp_id,
          student_id: payloadData.student_data.student_id,
          student_name: payloadData.student_data.student_name,
          subjective_answer: payloadData.subjective_answer,
          testType: payloadData.test_data.test_type_id,
          test_id: payloadData.test_data.test_id,
          test_start_time: payloadData.startTime,
          test_end_time: payloadData.test_data.test_end_timestamp,
          totalTimeLeft:
            payloadData.test_data.test_end_timestamp - payloadData.startTime,
          user_id: payloadData.student_data.userid,
          is_student_submit: isMannualSubmit,
        },
        institute_id: payloadData?.institute_data?.institute_id,
      },
    };

    try {
      await api.postAuthTZ(request).then((response) => {
        // console.log("✅ Test submitted successfully");

        if (
          payloadData.showscorecard &&
          parseInt(payloadData.test_settings.is_show_score) > 0
        ) {
          window.location.assign("/results");
        }

        props.dispatch({ type: "TEST_SUBMIT", testSubmitted: true });
      });
    } catch (error) {
      console.error("🚨 submitTestApi failed:", error);
      alert(i18n.t('test.submissionError'));
    }
  } else {
    props.dispatch({ type: "TEST_SUBMIT", testSubmitted: true });
  }
}
